jQuery(document).ready(function($) {
  if ($('.template--clean').length > 0) {
    console.log('clean template JS running')
    const baseUrl = getBaseUrl()
    let siteplanUrl = baseUrl
    let mapUrl = baseUrl

    function getBaseUrl() {
      return window.location.href
    }

    function updateSiteplanUrl(url) {
      $('#siteplan-link').attr('href', url)
      $('#siteplan-url').text(url)
    }

    function updateMapUrl(url) {
      $('#map-link').attr('href', url)
      $('#map-url').text(url)
    }

    function handleFormSubmission() {
      const devId = $('#dev').val()

      if (devId > 0) {
        $('.container__results').removeClass('hide')

        // Let's sort the siteplan out first
        siteplanUrl = baseUrl + '?development=' + devId

        updateSiteplanUrl(siteplanUrl)

        // Let's sort the map out
        mapUrl = baseUrl + '?development=' + devId + '&view=map'

        updateMapUrl(mapUrl)
      } else {
        $('.container__results').addClass('hide')
      }
    }

    function handleCopyClick(event) {
      event.preventDefault()
      let idToCopy = $(this).data('copy')
      let span = document.getElementById(idToCopy)
      console.log(span, span.textContent)

      let textArea = document.createElement('textarea')
      textArea.value = span.textContent
      document.body.appendChild(textArea)
      textArea.select()
      document.execCommand('Copy')
      textArea.remove()
    }

    $('#generate-urls').on('click', handleFormSubmission)
    $('#dev').on('change', handleFormSubmission)

    $('#siteplan-width').on('input', function() {
      let val = $(this).val()
      const devId = $('#dev').val()
      let currentUrl = new URL(getBaseUrl() + '?development=' + devId)
      currentUrl.searchParams.set('width', val)
      currentUrl.searchParams.set('height', $('#siteplan-height').val())

      updateSiteplanUrl(currentUrl)
    })

    $('#siteplan-height').on('input', function() {
      let val = $(this).val()
      const devId = $('#dev').val()
      let currentUrl = new URL(getBaseUrl() + '?development=' + devId)
      currentUrl.searchParams.set('height', val)
      currentUrl.searchParams.set('width', $('#siteplan-width').val())

      updateSiteplanUrl(currentUrl)
    })

    $('.btn--copy').on('click', handleCopyClick)
  }
})
